
const faqHeaders = document.querySelectorAll('.js-recruit-header');
const faqContents = document.querySelectorAll('.js-recruit-content');
gsap.set(faqContents, { display: 'none', opacity: 0 });

faqHeaders.forEach((faqHeader) => {
  faqHeader.addEventListener('click', function () {
    let faqContent = faqHeader.nextElementSibling;
    if (faqHeader.classList.contains('is-active')) {
      gsap.to(faqContent, {
        opacity: 0, duration: 0.5, onComplete: () => {
          faqContent.style.display = 'none';
        }
      });
      faqHeader.classList.remove('is-active');
    }
    else {
      faqContent.style.display = 'block';
      gsap.to(faqContent, { opacity: 1, duration: 0.5 });
      faqHeader.classList.add('is-active');
    }
  });
});
